module.exports = __webpack_public_path__ + "img/NP.c8a8ef36.svg";